/*
  sections/nr-help-centre.liquid: search box and deep links.

  The page works without this file (every answer opens on its own); it adds:
  - a search box that hides questions that don't match and opens those that do
  - opening the question named in the address (#question-id) on arrival
*/
if (!customElements.get('nr-help-search')) {
  customElements.define(
    'nr-help-search',
    class NrHelpSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.status = this.querySelector('[role="status"]');
        // Search covers the whole page, so questions can be split across
        // several help centre sections (each section holds up to 50 blocks).
        this.root = document.getElementById('MainContent') || document;
        this.items = Array.from(this.root.querySelectorAll('[data-help-item]'));
        this.groups = Array.from(this.root.querySelectorAll('[data-help-group]'));
        this.empty = this.root.querySelector('[data-help-empty]');
        this.nav = this.root.querySelector('.nr-help__topics-nav');
        this.addLaterChips();
        // Text is read once; answers are short so this stays cheap.
        this.texts = this.items.map((item) => item.textContent.toLowerCase());
        this.wasOpen = this.items.map((item) => item.open);
        this.searching = false;

        this.hidden = false;
        this.input.addEventListener('input', () => this.filter());
        this.openFromHash();
        window.addEventListener('hashchange', () => this.openFromHash());
      }

      filter() {
        const words = this.input.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
        let shown = 0;

        // Remember which answers the reader had open before the search began.
        if (words.length && !this.searching) this.wasOpen = this.items.map((item) => item.open);
        this.searching = words.length > 0;

        // Match the start of words, so "liver" doesn't find "delivery".
        const patterns = words.map((word) => new RegExp(`(^|[^a-z0-9])${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`));

        this.items.forEach((item, index) => {
          const match = patterns.every((pattern) => pattern.test(this.texts[index]));
          item.hidden = !match;
          // Open matches while searching; restore the reader's choice after.
          item.open = words.length ? match : this.wasOpen[index];
          if (match) shown += 1;
        });

        this.groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-help-item]:not([hidden])');
        });

        if (this.nav) this.nav.hidden = words.length > 0;
        if (this.empty) this.empty.hidden = shown > 0;
        this.status.textContent = words.length ? `${shown} ${shown === 1 ? 'question' : 'questions'}` : '';
      }

      // Topics in a later help centre section get a chip in the first
      // section's list too.
      addLaterChips() {
        const list = this.nav && this.nav.querySelector('ul');
        if (!list) return;
        const linked = new Set(Array.from(list.querySelectorAll('a')).map((a) => a.hash.slice(1)));
        this.groups.forEach((group) => {
          const title = group.querySelector('.nr-help__group-title');
          if (!group.id || !title || linked.has(group.id)) return;
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.className = 'nr-help__chip nr-chip';
          a.href = `#${group.id}`;
          a.textContent = title.textContent;
          li.appendChild(a);
          list.appendChild(li);
        });
      }

      openFromHash() {
        const id = decodeURIComponent(window.location.hash.slice(1));
        if (!id) return;
        const target = document.getElementById(id);
        if (target && target.matches('[data-help-item]')) {
          target.open = true;
          target.scrollIntoView({ block: 'start' });
        }
      }
    }
  );
}
